import React from 'react';

const socialLinks = [
  {
    href: 'https://www.facebook.com/p/Grill-Me-Crazy-GMC-100063609579017/',
    label: 'Facebook',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z'
  },
  {
    href: 'https://www.instagram.com/grillmecrazy.com.au/',
    label: 'Instagram',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z'
  },
  {
    href: 'https://www.tiktok.com/@grillmecrazy',
    label: 'TikTok',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z'
  }
];

const tradingHours = [
  { day: 'Monday', time: '11:00 AM - 9:00 PM' },
  { day: 'Tuesday', time: 'CLOSED' },
  { day: 'Wednesday', time: '11:00 AM - 9:00 PM' },
  { day: 'Thursday', time: '11:00 AM - 9:00 PM' },
  { day: 'Friday', time: '11:00 AM - 9:00 PM' },
  { day: 'Saturday', time: '11:00 AM - 9:00 PM' },
  { day: 'Sunday', time: '11:00 AM - 9:00 PM' },
];

const Footer: React.FC = () => {
  return (
    <footer
      className="w-full"
      style={{ maxWidth: '1920px', backgroundColor: '#0B5C33' }}
    >
      <div className="w-full flex flex-col lg:flex-row px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-10 sm:py-12 lg:py-16">
        {/* Left Side */}
        <div className="w-full lg:w-1/2 flex flex-col lg:pr-8 xl:pr-12 mb-10 lg:mb-0">
          {/* Row 1: Main Heading */}
          <div>
            <h2
              className="font-teko font-semibold leading-none"
              style={{ fontSize: 'clamp(32px, 6vw, 77.47px)', color: '#FFC600' }}
            >
              INDO-MEXICAN
            </h2>
            <h2
              className="font-teko font-semibold leading-none"
              style={{ fontSize: 'clamp(32px, 6vw, 77.47px)', color: '#FFC600' }}
            >
              RESTAURANT & BAR
            </h2>
          </div>

          {/* Row 2: Contact + Trading Hours */}
          <div className="flex flex-col sm:flex-row mt-6 gap-6 sm:gap-8">
            {/* Contact */}
            <div className="flex flex-col m-0 p-0" style={{ gap: '12px' }}>
              <div>
                <h3 className="font-teko font-semibold" style={{ fontSize: 'clamp(24px, 3.5vw, 40px)', color: '#FFFFFF' }}>PHONE</h3>
                <p className="font-inter font-normal" style={{ fontSize: 'clamp(14px, 1.8vw, 19px)', color: '#FFF2DA', marginTop: '6px' }}>08 89528112</p>
              </div>
              <div>
                <h3 className="font-teko font-semibold" style={{ fontSize: 'clamp(24px, 3.5vw, 40px)', color: '#FFFFFF' }}>EMAIL</h3>
                <p className="font-inter font-normal break-all" style={{ fontSize: 'clamp(14px, 1.8vw, 19px)', color: '#FFF2DA', marginTop: '6px' }}>contact@grillmecrazy.au</p>
              </div>
              <div>
                <h3 className="font-teko font-semibold" style={{ fontSize: 'clamp(24px, 3.5vw, 40px)', color: '#FFFFFF' }}>ADDRESS</h3>
                <p className="font-inter font-normal" style={{ fontSize: 'clamp(14px, 1.8vw, 19px)', color: '#FFF2DA', marginTop: '6px' }}>6/70 Todd St, Alice Springs NT 0870, Australia</p>
              </div>
              {/* Row 3: Social Icons */}
              <div className="flex items-center mt-4 sm:mt-8" style={{ gap: '16px' }}>
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex items-center justify-center overflow-hidden transition-all duration-300"
                    style={{ width: '36px', height: '36px', borderRadius: '10px', backgroundColor: '#FFC600' }}
                    aria-label={social.label}
                  >
                    <span className="absolute inset-0 transition-opacity duration-300 opacity-100 group-hover:opacity-0" style={{ backgroundColor: '#FFC600' }}></span>
                    <span className="absolute inset-0 transition-opacity duration-300 opacity-0 group-hover:opacity-100" style={{ backgroundColor: '#027C3F' }}></span>
                    <svg className="absolute transition-all duration-300 opacity-100 group-hover:opacity-0" style={{ width: '24px', height: '24px', fill: '#027C3F' }} viewBox="0 0 24 24">
                      <path d={social.path} />
                    </svg>
                    <svg className="absolute transition-all duration-300 opacity-0 group-hover:opacity-100" style={{ width: '24px', height: '24px', fill: '#FFC600' }} viewBox="0 0 24 24">
                      <path d={social.path} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>

            {/* Trading Hours */}
            <div className="flex flex-col m-0 p-0">
              <h3 className="font-teko font-semibold" style={{ fontSize: 'clamp(24px, 3.5vw, 40px)', color: '#FFFFFF' }}>TRADING HOURS</h3>
              <div className="flex flex-col mt-1" style={{ gap: '4px' }}>
                {tradingHours.map((item) => (
                  <div key={item.day} className="flex items-center" style={{ gap: '12px' }}>
                    <span className="font-inter font-normal" style={{ fontSize: 'clamp(13px, 1.6vw, 19px)', color: '#FFF2DA', minWidth: 'clamp(70px, 10vw, 105px)' }}>{item.day}</span>
                    <span className="font-inter font-normal" style={{ fontSize: 'clamp(13px, 1.6vw, 19px)', color: '#FFF2DA' }}>{item.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="w-full lg:w-1/2 flex flex-col lg:pl-8 xl:pl-12">
          {/* Row 1: FIND US heading */}
          <div>
            <h3 className="font-teko font-semibold" style={{ fontSize: 'clamp(28px, 4vw, 48px)', color: '#FFC600' }}>FIND US</h3>
          </div>

          {/* Row 2: Line + Map */}
          <div className="flex flex-col flex-1 mt-6 sm:mt-8">
            <div className="w-full h-px bg-white mb-4 sm:mb-6"></div>
            <div className="w-full flex-1 overflow-hidden" style={{ borderRadius: '8px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.3!2d133.8807!3d-23.698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDQxJzUyLjgiUyAxMzPCsDUyJzQ5LjAiRQ!5e0!3m2!1sen!2sau!4v1710000000000!5m2!1sen!2sau"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '250px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Grill Me Crazy Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* White Separator Line */}
      <div className="w-full px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24">
        <div style={{ height: '1px', backgroundColor: '#FFFFFF' }}></div>
      </div>

      {/* Copyright Bar */}
      <div className="w-full flex flex-col sm:flex-row items-center justify-between px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-5">
        <p className="font-inter" style={{ fontSize: 'clamp(12px, 1.4vw, 14px)', color: '#FFF2DA', margin: 0 }}>
          &copy; 2026 All Rights Reserved.
        </p>
        <p className="font-inter" style={{ fontSize: 'clamp(12px, 1.4vw, 14px)', color: '#FFF2DA', margin: 0 }}>
          Developed by <span style={{ color: '#FFC600' }}>Socians</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
